import styled from 'styled-components'

export const ModalContentWrap = styled.div`
  width: 100%;
  margin: auto;
  &.fade-enter {
    opacity: 0;
  }
  &.fade-exit {
    opacity: 1;
  }
  &.fade-enter-active {
    opacity: 1;
    transition: opacity 0.5s ease-in;
  }
  &.fade-exit-active {
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }
`
